import './App.css';
import { Login } from './auth/Auth';
import { Habits } from './habits/Habits';
import { HabitCard } from './habits/HabitCard';
import { ConnectedAgents } from './agents/ConnectedAgents';
import ProtectedRoute from './ProtectedRoute';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import * as React from 'react'
import { ChakraProvider } from '@chakra-ui/react'


function App() {
  return (
    <React.StrictMode>
      <ChakraProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/habits" element={<ProtectedRoute> <Habits /></ProtectedRoute>} />
            <Route path="/habits/:id" element={<ProtectedRoute> <HabitCard /></ProtectedRoute>} />
            <Route path="/agents" element={<ProtectedRoute><ConnectedAgents /></ProtectedRoute>} />
            <Route path="/" element={<Navigate replace to="/habits" />} />
          </Routes>
        </Router>
      </ChakraProvider>
    </React.StrictMode>
  );
}

export default App;
